<template>
	<drawer
		title="Pay invoice"
		z-index="100"
		@updateClose="onClose"
		@updateSave="onSave"
	>
		<div class="subtext">Invoice ID: {{ invoice_id }}</div>
	  <field
			  margin="20px 0 10px 0"
			  width="300px"
			  label="Customer"
			  :setInputValue="customer"
			  is-readonly
	  ></field>
	  <field
			  margin="0 0 10px 0"
			  width="300px"
			  type="text"
			  label="Pay date"
			  placeholder="MM/DD/YYYY"
			  display-format="YYYY-MM-DD hh:mm"
			  :dateValue="date"
			  @updateDate="onTime"
			  is-date
			  is-attach
			  is-no-title
	  ></field>
		<field
				:class-error="!lost && $v.amount && $v.amount.$error"
				margin="0 0 10px 0"
				width="300px"
				label="Amount"
				placeholder="Enter amount"
				type="number"
				:setInputValue="amount"
				@updateInput="onInput($event, 'amount')"
				:is-required="!lost"
				icon="dollar"
		/>
	  <field
			  margin="0 0 20px 0"
			  width="300px"
			  label="Note"
			  placeholder="Enter text"
			  :setInputValue="notes"
			  @updateInput="onInput($event, 'notes')"
			  is-textarea
	  ></field>
			<template
			  v-for="({ id, value, status }, idx) in pay_method">
		  <field
			    :key="id"
				  margin="0 0 10px 0"
				  padding="0"
				  height="24"
			    :idx="idx"
				  :label-switch="value"
				  :switch-value="status"
				  @updateSwitch="onCheckbox"
				  is-dense
				  is-checkbox
				  is-off-style
		  ></field>
			</template>
		<field
				width="100%"
				margin="0"
				label-switch="📉 Add expenses"
				:switch-value="lost"
				@updateSwitch="onSwitch($event, 'lost')"
				is-switch
				is-off-style
				is-dense
		></field>
		<template v-if="lost">
			<field
					:class-error="$v.lost_amount && $v.lost_amount.$error"
					margin="0 0 10px 0"
					width="300px"
					label="Lost payment"
					placeholder="Enter amount"
					type="number"
					:setInputValue="lost_amount"
					@updateInput="onInput($event, 'lost_amount')"
					is-required
					icon="dollar"
			></field>
			<field
					:class-error="$v.lost_notes && $v.lost_notes.$error"
					margin="0 0 20px 0"
					width="300px"
					label="Description of the lost payment"
					placeholder="Enter text"
					:setInputValue="lost_notes"
					@updateInput="onInput($event, 'lost_notes')"
					is-textarea
					is-required
			></field>

			<v-radio-group v-model="type" dense row>
				<v-radio class="gender" label="🤦 Mistake" :value="1"></v-radio>
				<v-radio class="gender" label="📉 Loss" :value="2"></v-radio>
			</v-radio-group>

		</template>

	</drawer>
</template>

<script>
import getDefaultDate from "@/helper/getDefaultDate";
import Drawer from "@/shared/Drawer/Drawer";
import { required, helpers } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapActions } from "vuex";

export default {
	name: "CustomerInvoicesPayments",
	mixins: [ validationMixin ],
	components: { Drawer },
	props: {
		customerInvoicesPayment: Object
	},
	data: () => ({
		lost: false,
		lost_amount: null,
		lost_notes: null,
		amount: null,
		customer: '',
		invoice_id: '',
		notes: '',
		date: getDefaultDate(),
		pay_method: null,
		type: 1,
	}),
	validations() {
		const requiredIfNotLost = helpers.withParams(
			{ type: 'requiredIfNotLost' },
			function(value, parentVm) {
				return !parentVm.lost ? required(value) : true;
			}
		);

		const requiredIfLost = helpers.withParams(
			{ type: 'requiredIfLost' },
			function(value, parentVm) {
				return parentVm.lost ? required(value) : true;
			}
		);

		return {
			amount: { required: requiredIfNotLost },
			lost_amount: { required: requiredIfLost },
			lost_notes: { required: requiredIfLost }
		};
	},
	methods: {
		...mapActions([ 'onCustomerInvoicesPayment', 'setAlert' ]),
		requiredIfLost() {
			return this.lost ? required : () => true;
		},
		onClose(isRefresh) {
			this.$emit('updateClose', isRefresh);
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { amount, customer, invoice_id, notes, date, pay_method, lost, lost_amount, lost_notes, type } = this.$data;
				const values = {
					amount,
					customer,
					invoice_id,
					notes,
					date,
					pay_method,
					lost,
					lost_amount,
					lost_notes,
					type
				};
				
				await this.onCustomerInvoicesPayment(values);
				this.onClose(1);
			} else {
				this.setAlert({ type: "error", message: "Amount field is required" });
			}
		},
		onTime(date) {
			this.date = date;
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onCheckbox({ value, idx }) {
			this.pay_method[idx].status = value;
		},
		onSwitch({ value }, key) {
			this[key] = value;
		},
	},
	mounted() {
		for (const key in this.customerInvoicesPayment) {
			this[key] = this.customerInvoicesPayment[key];
		}
	}
};
</script>

<style>
	.subtext {
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0.25px;
			color: #71CC82;
	}
</style>
